/** Normalize ExcelJS / fetch buffers for Blob (fixes Android corrupt downloads). */
export function toUint8Array(buffer) {
  if (buffer instanceof Uint8Array) {
    return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
  }
  if (buffer instanceof ArrayBuffer) {
    return new Uint8Array(buffer);
  }
  return new Uint8Array(buffer);
}

/** UTF-8 BOM bytes — Excel / Google Sheets on mobile open reliably. */
export function encodeUtf8Csv(text) {
  const body = String(text).replace(/^\uFEFF/, '');
  const encoded = new TextEncoder().encode(body);
  const out = new Uint8Array(3 + encoded.length);
  out[0] = 0xef;
  out[1] = 0xbb;
  out[2] = 0xbf;
  out.set(encoded, 3);
  return out;
}

export async function downloadBytes(bytes, filename, mimeType) {
  const u8 = toUint8Array(bytes);
  const blob = new Blob([u8], { type: mimeType });

  if (typeof navigator !== 'undefined' && typeof File !== 'undefined') {
    try {
      const file = new File([blob], filename, { type: mimeType });
      const canShareFiles = mimeType.startsWith('text/csv')
        && navigator.canShare?.({ files: [file] });
      if (canShareFiles) {
        await navigator.share({ files: [file], title: filename });
        return;
      }
    } catch (err) {
      if (err?.name === 'AbortError') return;
    }
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  window.setTimeout(() => {
    a.remove();
    URL.revokeObjectURL(url);
  }, 500);
}
